import * as pdfjsLib from 'pdfjs-dist';

// Create a singleton for PDF.js initialization
let isInitialized = false;

// Initialize PDF.js
const initializePdfJs = () => {
  if (!isInitialized) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;
    isInitialized = true;
    console.log('PDF.js initialized with worker:', pdfjsLib.GlobalWorkerOptions.workerSrc);
  }
};

// Debug function to log detailed PDF content to console
export const debugLogPdfContent = async (pdfBytes: Uint8Array): Promise<void> => {
  try {
    // Ensure PDF.js is initialized
    initializePdfJs();
    
    // Create blob URL for PDF viewer debugging
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    console.log('PDF debug URL (copy to browser):', url);
    
    // Load the PDF
    const loadingTask = pdfjsLib.getDocument({ data: pdfBytes });
    const pdf = await loadingTask.promise;
    console.log(`PDF loaded with ${pdf.numPages} pages`);
    
    // Process each page
    for (let i = 1; i <= pdf.numPages; i++) {
      console.log(`--- EXTRACTING PAGE ${i} ---`);
      const page = await pdf.getPage(i);
      
      // Get text content with positions
      const textContent = await page.getTextContent();
      
      // Log items with positions for debugging
      console.log(`Page ${i} has ${textContent.items.length} text elements`);
      
      // Group text items by approximate y-position (likely same line)
      const lineMap = new Map<number, string[]>();
      const yTolerance = 5; // pixels of tolerance for same line
      
      textContent.items.forEach((item: any) => {
        // Round the y-position to group nearby items
        const yPos = Math.round(item.transform[5] / yTolerance) * yTolerance;
        
        if (!lineMap.has(yPos)) {
          lineMap.set(yPos, []);
        }
        
        lineMap.get(yPos)?.push(item.str);
      });
      
      // Sort by y-position (top to bottom) and print lines
      const sortedYPositions = Array.from(lineMap.keys()).sort((a, b) => b - a);
      
      sortedYPositions.forEach((yPos) => {
        const line = lineMap.get(yPos)?.join(' ') || '';
        console.log(`Line at y=${yPos}: ${line}`);
        
        // Check for BOL patterns
        if (
          /BOL|Bill\s*of\s*Lading|B\/L|BL|bill lading/i.test(line) ||
          /\b\d{6,10}\b/.test(line)
        ) {
          console.log('POTENTIAL BOL LINE:', line);
        }
        
        // Check for shipment number patterns
        if (
          /Shipment|Load|Reference|Order|Trip|Pro|SCAC/i.test(line) ||
          /\b[A-Z]{3,4}\d{6,10}\b/.test(line)
        ) {
          console.log('POTENTIAL SHIPMENT LINE:', line);
        }
        
        // Check for date patterns
        if (
          /Date|Delivery|Del|Time|Schedule|appt|appointment/i.test(line) &&
          /\d{1,2}[\/\-\.]\d{1,2}[\/\-\.]\d{2,4}/.test(line)
        ) {
          console.log('POTENTIAL DATE LINE:', line);
        }
      });
    }
    
    console.log('--- PDF DEBUGGING COMPLETE ---');
  } catch (error) {
    console.error('Error in PDF debug:', error);
  }
};

// Export initialization for use elsewhere
export const initPdfJs = initializePdfJs; 